const FEATURE_TOGGLES_READY_MUTATION = 'featureToggles/setFeatures'

const embedAppPlugin = (store) => {
  store.subscribe((mutation) => {
    if (mutation.type !== FEATURE_TOGGLES_READY_MUTATION) return
    store.dispatch('embedApp/loadManifests')
  })
}

export default embedAppPlugin
